import type { UserDetails } from '@/components/Worlds/types'

import { SUBWORLD_EVENT_NOTIFICATION_URL } from './constants'
import type { UserEventType } from './types'

export default function getSubworldEventNotificationURL({
  user,
  userEvent,
}: {
  user: Pick<UserDetails, 'id' | 'username'>
  userEvent: UserEventType
}): string {
  const { type } = userEvent
  const notificationUrl = SUBWORLD_EVENT_NOTIFICATION_URL[type]

  return notificationUrl({ event: userEvent, user })
}
